var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXAddserviceicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "46px",
    viewBox: "0 0 20 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add service icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-service-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 16.000000)",
    fill: "#933CC1",
    id: "Fill-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4384615,5.97692308 L8.56153846,5.97692308 L8.56153846,2.1 C8.56153846,1.38535385 7.98387692,0.807692308 7.26923077,0.807692308 C6.55458462,0.807692308 5.97692308,1.38535385 5.97692308,2.1 L5.97692308,5.97692308 L2.1,5.97692308 C1.38535385,5.97692308 0.807692308,6.55458462 0.807692308,7.26923077 C0.807692308,7.98387692 1.38535385,8.56153846 2.1,8.56153846 L5.97692308,8.56153846 L5.97692308,12.4384615 C5.97692308,13.1531077 6.55458462,13.7307692 7.26923077,13.7307692 C7.98387692,13.7307692 8.56153846,13.1531077 8.56153846,12.4384615 L8.56153846,8.56153846 L12.4384615,8.56153846 C13.1531077,8.56153846 13.7307692,7.98387692 13.7307692,7.26923077 C13.7307692,6.55458462 13.1531077,5.97692308 12.4384615,5.97692308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAddserviceicon);
export default __webpack_public_path__ + "static/media/xAddserviceicon.6a631c05924fcd1d9dcab3f95620ceb9.svg";
export { ForwardRef as ReactComponent };